import React, { useState } from 'react';
import { ShieldAlert, Users, FileText, AlertTriangle, CheckCircle, XCircle, Search, Flag, Filter, Eye, Download, Maximize2, MoreHorizontal, Trash2 } from 'lucide-react';
import { DashboardLayout } from '../components/DashboardLayout';
export function AdminDashboardPage() {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [showFilters, setShowFilters] = useState(false);
  const navItems = [{
    label: 'Verification Queue',
    icon: FileText,
    path: '/admin',
    badge: '12'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Disputes',
    icon: Flag,
    path: '/admin/disputes'
  }, {
    label: 'Risk Analysis',
    icon: AlertTriangle,
    path: '/admin/risk'
  }];
  const toggleItem = (id: string) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter(item => item !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-red-100 text-red-800 border-red-200" navItems={navItems} userInitials="AD" data-id="element-1522">
      <div data-testid="admin-dashboard-page" className="space-y-8" data-id="element-1523">
        <div data-testid="admin-dashboard-header" className="flex justify-between items-end mb-8" data-id="element-1524">
          <h1 data-testid="admin-dashboard-title" className="text-2xl font-bold" data-id="element-1525">
            Verification Queue
          </h1>
          <div className="flex gap-2" data-id="element-1526">
            <button data-testid="admin-dashboard-export-btn" className="px-4 py-2 bg-white border border-gray-300 text-sm font-bold flex items-center gap-2 hover:bg-gray-50" data-id="element-1527">
              <Download className="w-4 h-4" data-id="element-1528" /> Export Report
            </button>
          </div>
        </div>

        <div data-testid="admin-dashboard-stats" className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-1529">
          <div data-testid="admin-dashboard-pending-card" className="bg-white border border-gray-300 p-6 border-l-4 border-l-yellow-500" data-id="element-1530">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1531">
              Pending Review
            </h3>
            <p data-testid="admin-dashboard-pending-count" className="text-3xl font-bold" data-id="element-1532">
              12
            </p>
          </div>
          <div data-testid="admin-dashboard-verified-card" className="bg-white border border-gray-300 p-6 border-l-4 border-l-green-500" data-id="element-1533">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1534">
              Verified Today
            </h3>
            <p data-testid="admin-dashboard-verified-count" className="text-3xl font-bold" data-id="element-1535">
              45
            </p>
          </div>
          <div data-testid="admin-dashboard-rejected-card" className="bg-white border border-gray-300 p-6 border-l-4 border-l-red-500" data-id="element-1536">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1537">
              Rejected
            </h3>
            <p data-testid="admin-dashboard-rejected-count" className="text-3xl font-bold" data-id="element-1538">
              3
            </p>
          </div>
          <div data-testid="admin-dashboard-avg-time-card" className="bg-white border border-gray-300 p-6 border-l-4 border-l-blue-500" data-id="element-1539">
            <h3 className="text-xs font-mono text-gray-500 uppercase mb-2" data-id="element-1540">
              Avg Review Time
            </h3>
            <p data-testid="admin-dashboard-avg-time" className="text-3xl font-bold" data-id="element-1541">
              4.2h
            </p>
          </div>
        </div>

        {selectedItems.length > 0 && <div data-testid="admin-dashboard-bulk-actions" className="bg-[#1f2933] text-white p-4 mb-4 flex justify-between items-center shadow-lg animate-in fade-in slide-in-from-top-2" data-id="element-1542">
            <div className="font-bold text-sm flex items-center gap-2" data-id="element-1543">
              <span data-testid="admin-dashboard-selected-count" className="bg-white text-black px-2 py-0.5 rounded text-xs" data-id="element-1544">
                {selectedItems.length}
              </span>
              items selected
            </div>
            <div className="flex gap-3" data-id="element-1545">
              <button data-testid="admin-dashboard-approve-all-btn" className="px-3 py-1.5 bg-green-600 hover:bg-green-500 text-xs font-bold rounded flex items-center gap-2" data-id="element-1546">
                <CheckCircle className="w-3 h-3" data-id="element-1547" /> Approve All
              </button>
              <button data-testid="admin-dashboard-reject-all-btn" className="px-3 py-1.5 bg-red-600 hover:bg-red-500 text-xs font-bold rounded flex items-center gap-2" data-id="element-1548">
                <XCircle className="w-3 h-3" data-id="element-1549" /> Reject All
              </button>
              <button data-testid="admin-dashboard-flag-all-btn" className="px-3 py-1.5 bg-gray-700 hover:bg-gray-600 text-xs font-bold rounded flex items-center gap-2" data-id="element-1550">
                <Flag className="w-3 h-3" data-id="element-1551" /> Flag for Review
              </button>
            </div>
          </div>}

        <div data-testid="admin-dashboard-queue-table" className="bg-white border border-gray-300 mb-8" data-id="element-1552">
          <div className="p-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4 bg-gray-50" data-id="element-1553">
            <div className="relative w-full md:w-64" data-id="element-1554">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1555" />
              <input data-testid="admin-dashboard-search-input" type="text" placeholder="Search listing ID or seller..." className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-sm text-sm focus:outline-none focus:border-gray-500" data-id="element-1556" />
            </div>
            <div className="flex gap-2 w-full md:w-auto justify-end items-center" data-id="element-1557">
              <button data-testid="admin-dashboard-filter-toggle-btn" onClick={() => setShowFilters(!showFilters)} className={`p-2 border ${showFilters ? 'bg-gray-200 border-gray-400' : 'bg-white border-gray-300'} hover:bg-gray-100`} data-id="element-1558">
                <Filter className="w-4 h-4 text-gray-600" data-id="element-1559" />
              </button>

              {showFilters && <div data-testid="admin-dashboard-filters" className="flex gap-2 animate-in fade-in zoom-in-95" data-id="element-1560">
                  <select data-testid="admin-dashboard-risk-filter" className="text-sm border border-gray-300 p-2 bg-white" data-id="element-1561">
                    <option data-id="element-1562">Risk: All</option>
                    <option data-id="element-1563">High Risk</option>
                    <option data-id="element-1564">Medium Risk</option>
                    <option data-id="element-1565">Low Risk</option>
                  </select>
                  <select data-testid="admin-dashboard-docs-filter" className="text-sm border border-gray-300 p-2 bg-white" data-id="element-1566">
                    <option data-id="element-1567">Docs: All</option>
                    <option data-id="element-1568">Complete</option>
                    <option data-id="element-1569">Incomplete</option>
                  </select>
                  <select data-testid="admin-dashboard-seller-filter" className="text-sm border border-gray-300 p-2 bg-white" data-id="element-1570">
                    <option data-id="element-1571">Seller: All</option>
                    <option data-id="element-1572">Developer</option>
                    <option data-id="element-1573">Individual</option>
                  </select>
                </div>}
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-1574">
            <table className="w-full text-left text-sm min-w-[800px]" data-id="element-1575">
              <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-1576">
                <tr data-id="element-1577">
                  <th className="p-4 w-10" data-id="element-1578">
                    <input data-testid="admin-dashboard-select-all-checkbox" type="checkbox" className="rounded border-gray-300" onChange={e => {
                    if (e.target.checked) setSelectedItems(['CP-2991', 'CP-2994', 'CP-2988', 'CP-2982']);else setSelectedItems([]);
                  }} checked={selectedItems.length === 4} data-id="element-1579" />
                  </th>
                  <th className="p-4 font-bold" data-id="element-1580">Listing ID</th>
                  <th className="p-4 font-bold" data-id="element-1581">Seller</th>
                  <th className="p-4 font-bold" data-id="element-1582">Submitted</th>
                  <th className="p-4 font-bold" data-id="element-1583">Documents</th>
                  <th className="p-4 font-bold" data-id="element-1584">Risk Score</th>
                  <th className="p-4 font-bold text-right" data-id="element-1585">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-1586">
                {[{
                id: 'CP-2991',
                seller: 'Rajesh Kumar',
                type: 'Individual',
                time: '2h ago',
                docs: '4/4',
                risk: 'Low'
              }, {
                id: 'CP-2994',
                seller: 'Sunrise Developers',
                type: 'Developer',
                time: '3h ago',
                docs: '12/12',
                risk: 'Low'
              }, {
                id: 'CP-2988',
                seller: 'Amit Shah',
                type: 'Individual',
                time: '5h ago',
                docs: '3/4',
                risk: 'Medium'
              }, {
                id: 'CP-2982',
                seller: 'Unknown Entity',
                type: 'Suspicious Seller',
                time: '1d ago',
                docs: '1/4',
                risk: 'High'
              }].map((item, i) => <tr key={i} data-testid={`admin-dashboard-queue-row-${i + 1}`} className={`hover:bg-gray-50 ${selectedItems.includes(item.id) ? 'bg-blue-50' : ''}`} data-id="element-1587">
                    <td className="p-4" data-id="element-1588">
                      <input data-testid={`admin-dashboard-queue-row-${i + 1}-checkbox`} type="checkbox" className="rounded border-gray-300" checked={selectedItems.includes(item.id)} onChange={() => toggleItem(item.id)} data-id="element-1589" />
                    </td>
                    <td className="p-4 font-mono font-bold" data-id="element-1590">{item.id}</td>
                    <td className="p-4" data-id="element-1591">
                      <div className="font-bold" data-id="element-1592">{item.seller}</div>
                      <div className="text-xs text-gray-500" data-id="element-1593">{item.type}</div>
                    </td>
                    <td className="p-4 font-mono text-xs" data-id="element-1594">{item.time}</td>
                    <td className="p-4" data-id="element-1595">
                      <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 text-xs font-bold rounded border border-blue-100" data-id="element-1596">
                        <FileText className="w-3 h-3" data-id="element-1597" /> {item.docs}
                      </span>
                    </td>
                    <td className="p-4" data-id="element-1598">
                      <span data-testid={`admin-dashboard-queue-row-${i + 1}-risk`} className={`inline-block px-2 py-1 text-xs font-bold rounded border ${item.risk === 'Low' ? 'bg-green-50 text-green-700 border-green-200' : item.risk === 'Medium' ? 'bg-yellow-50 text-yellow-700 border-yellow-200' : 'bg-red-50 text-red-700 border-red-200'}`} data-id="element-1599">
                        {item.risk.toUpperCase()}
                      </span>
                    </td>
                    <td className="p-4 text-right" data-id="element-1600">
                      <div className="flex justify-end gap-2" data-id="element-1601">
                        <button data-testid={`admin-dashboard-queue-row-${i + 1}-approve-btn`} className="p-1.5 bg-green-100 text-green-700 rounded hover:bg-green-200" title="Approve" data-id="element-1602">
                          <CheckCircle className="w-4 h-4" data-id="element-1603" />
                        </button>
                        <button data-testid={`admin-dashboard-queue-row-${i + 1}-reject-btn`} className="p-1.5 bg-red-100 text-red-700 rounded hover:bg-red-200" title="Reject" data-id="element-1604">
                          <XCircle className="w-4 h-4" data-id="element-1605" />
                        </button>
                        <button data-testid={`admin-dashboard-queue-row-${i + 1}-review-btn`} className="px-3 py-1.5 border border-gray-300 text-xs font-bold hover:bg-gray-100 rounded" data-id="element-1606">
                          Review
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div data-testid="admin-dashboard-document-viewer" className="grid grid-cols-1 lg:grid-cols-2 gap-0 border border-gray-300 bg-white h-[600px]" data-id="element-1607">
          <div className="border-r border-gray-300 flex flex-col" data-id="element-1608">
            <div className="p-3 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-1609">
              <h3 className="font-bold text-sm flex items-center gap-2" data-id="element-1610">
                <FileText className="w-4 h-4" data-id="element-1611" /> Sale_Deed_Draft.pdf
              </h3>
              <div className="flex gap-2" data-id="element-1612">
                <button data-testid="admin-dashboard-maximize-btn" className="p-1 hover:bg-gray-200 rounded" data-id="element-1613">
                  <Maximize2 className="w-4 h-4" data-id="element-1614" />
                </button>
                <button data-testid="admin-dashboard-download-doc-btn" className="p-1 hover:bg-gray-200 rounded" data-id="element-1615">
                  <Download className="w-4 h-4" data-id="element-1616" />
                </button>
              </div>
            </div>
            <div className="flex-1 bg-gray-100 p-8 flex items-center justify-center overflow-auto" data-id="element-1617">
              <div className="w-full max-w-[400px] aspect-[1/1.4] bg-white shadow-lg border border-gray-200 p-8" data-id="element-1618">
                <div className="w-full h-4 bg-gray-200 mb-4" data-id="element-1619"></div>
                <div className="w-3/4 h-4 bg-gray-200 mb-8" data-id="element-1620"></div>
                <div className="space-y-2" data-id="element-1621">
                  {[...Array(12)].map((_, i) => <div key={i} className="w-full h-2 bg-gray-100" data-id="element-1622"></div>)}
                </div>
                <div className="mt-8 border-2 border-red-500 bg-red-50/20 h-20 w-full flex items-center justify-center" data-id="element-1623">
                  <span className="text-xs font-bold text-red-600 bg-white px-2" data-id="element-1624">
                    Signature Mismatch
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col" data-id="element-1625">
            <div className="p-3 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-1626">
              <h3 className="font-bold text-sm" data-id="element-1627">Extracted Data (OCR)</h3>
              <span className="text-xs font-mono text-green-600 bg-green-50 px-2 py-1 rounded border border-green-200" data-id="element-1628">
                98% Confidence
              </span>
            </div>
            <div className="flex-1 p-6 overflow-auto" data-id="element-1629">
              <div className="space-y-6" data-id="element-1630">
                <div data-id="element-1631">
                  <label className="text-xs font-mono text-gray-500 block mb-1" data-id="element-1632">
                    Property Owner
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1633">
                    <input data-testid="admin-dashboard-owner-input" type="text" value="Rajesh Kumar" className="w-full p-2 border border-green-300 bg-green-50 text-sm font-bold" readOnly data-id="element-1634" />
                    <CheckCircle className="w-4 h-4 text-green-500" data-id="element-1635" />
                  </div>
                </div>

                <div data-id="element-1636">
                  <label className="text-xs font-mono text-gray-500 block mb-1" data-id="element-1637">
                    Survey Number
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1638">
                    <input data-testid="admin-dashboard-survey-input" type="text" value="45/2/A" className="w-full p-2 border border-gray-300 text-sm" data-id="element-1639" />
                    <button className="text-gray-400 hover:text-gray-600" data-id="element-1640">
                      <CheckCircle className="w-4 h-4" data-id="element-1641" />
                    </button>
                  </div>
                </div>

                <div data-id="element-1642">
                  <label className="text-xs font-mono text-gray-500 block mb-1" data-id="element-1643">
                    Area (Sq. Ft)
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1644">
                    <input data-testid="admin-dashboard-area-input" type="text" value="2400" className="w-full p-2 border border-red-300 bg-red-50 text-sm" data-id="element-1645" />
                    <AlertTriangle className="w-4 h-4 text-red-500" data-id="element-1646" />
                  </div>
                  <p className="text-xs text-red-600 mt-1" data-id="element-1647">
                    Mismatch with listing data (2500)
                  </p>
                </div>

                <div className="pt-6 border-t border-gray-200" data-id="element-1648">
                  <label className="text-xs font-bold block mb-2" data-id="element-1649">
                    Admin Notes
                  </label>
                  <textarea data-testid="admin-dashboard-notes-textarea" className="w-full border border-gray-300 p-2 text-sm h-24" placeholder="Add verification notes..." data-id="element-1650"></textarea>
                </div>
              </div>
            </div>
            <div className="p-4 border-t border-gray-200 bg-gray-50 flex justify-end gap-3" data-id="element-1651">
              <button data-testid="admin-dashboard-request-reupload-btn" className="px-4 py-2 border border-gray-300 bg-white text-sm font-bold hover:bg-gray-100" data-id="element-1652">
                Request Re-upload
              </button>
              <button data-testid="admin-dashboard-verify-doc-btn" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1653">
                Verify Document
              </button>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}